export const rangesSubMenu = [{
  path: '/ranges/list/',
  component: () => import('@/views/ranges/list.vue'),
  name: 'productManagement.range.title',
  meta: {
    title: 'productManagement.range.title',
    roles: ['Super Admin', 'Admin', 'Sales Manager', 'Order Manager'],
    noCache: true,
    icon: 'tree'
  }
}, {
  path: '/ranges/edit/:id(\\d+)',
  component: () => import('@/views/ranges/manage.vue'),
  name: 'productManagement.range.manage',
  props: {
    isEdit: true
  },
  meta: {
    title: 'productManagement.range.manage',
    noCache: true,
    activeMenu: '/ranges/list',
    hidden: true
  }
}, {
  path: '/ranges/add',
  component: () => import('@/views/ranges/manage.vue'),
  name: 'productManagement.range.manage',
  props: {
    isEdit: false
  },
  meta: {
    title: 'productManagement.range.manage',
    noCache: true,
    activeMenu: '/ranges/list',
    hidden: true
  }
}];